<div class="flex flex-grow justify-center items-center" *ngFor="let topic of topics">
  <div class="bg-blue-300 rounded-xl justify-center items-center p-2">{{ topic }}</div>
</div>
